'use strict';

require('js/libs/modernizr-custom');

require('js/compatibility');

var _fastclick = require('fastclick');

var _fastclick2 = _interopRequireDefault(_fastclick);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if ('addEventListener' in document) {
    document.addEventListener('DOMContentLoaded', function () {
        new _fastclick2.default(document.body);
    }, false);
}
//# sourceMappingURL=head.js.map
